import { FaCheckCircle } from "react-icons/fa";
import { templates } from "../../data/constant";
import Popover from "../ui/Popover";
import { useEffect, useState } from "react";

// Component for displaying and selecting templates in a dropdown
function TemplateDropdown({selectedTemplate=templates[0], setSelectedTemplate, onTemplateChange}) {
  const [isOpen, setIsOpen] = useState(false);

  // Handle template selection and close dropdown
  const handleSelect = (value) => {
    setSelectedTemplate(value);
    onTemplateChange(value);
    setIsOpen(false);
    console.info('Template selected and dropdown closed');
  };

  // Reset template selection when dropdown closes
  useEffect(() => {
    if (!isOpen) {
      setSelectedTemplate(selectedTemplate);
      console.info('Template selection reset on dropdown close');
    }
  }, [isOpen, selectedTemplate]);

  return (
    <Popover
      isOpen={isOpen}
      onOpenChange={setIsOpen}
      label="Template"
      onSelect={handleSelect}
      width="280px"
    >
      <div className="p-4">
        <div className="max-h-[50vh] overflow-y-auto">
          {templates.map((template) => (
            <div
              key={template.id}
              onClick={() => handleSelect(template)}
              className="flex items-center gap-4 p-3 hover:bg-gray-50 cursor-pointer border-b"
            >
              <div 
                className="w-20 h-12 border rounded"
                style={{
                  backgroundImage: `url(${template.background})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}
              />
              <span className="flex-1">{template.name}</span>
              {selectedTemplate?.id === template.id && (
                <FaCheckCircle className="h-5 w-5 text-[#1f36c7]" />
              )}
            </div>
          ))}
        </div>
      </div>
    </Popover>
  );
}

export default TemplateDropdown;